<template>
    <div class="box-point-account bg-white max-w-2xl m-auto rounded-10 py-0 px-4 mt-3">
        <ProfileMenuItem :menuTitle="lbl.profile.address" url="/deliveryaddress">
            <img class="h-25px" src="../../../../../assets/profile_icon/address.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.credit" url="/card">
            <img class="h-25px" src="../../../../../assets/profile_icon/Credit.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.tax_invoice" url="/taxaddress">
            <img class="h-25px" src="../../../../../assets/profile_icon/tax.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.my_favorite" url="/favorite">
            <img class="h-25px" src="../../../../../assets/profile_icon/Fav.svg">
        </ProfileMenuItem>
        <ProfileMenuItem :menuTitle="lbl.profile.change_mobile_pin" url="/changepass" :noBorder="true">
            <img class="h-25px" src="../../../../../assets/profile_icon/fingerprint.svg">
        </ProfileMenuItem>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import ProfileMenuItem from './ProfileMenuItem.vue'
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    mixins: [LocaleMixin],
    components: {
        ProfileMenuItem,
    },
    computed: {
        isLoginFacebook: function () {
            let user = Account.getCacheUser();
            let loginChanel = user.loginChanel;
            return loginChanel == 'facebook';
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
